import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Asset } from '@shared/models/asset.model';
import {
  MatLegacyDialog as MatDialog
} from '@angular/material/legacy-dialog';
import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { AssetType } from '@shared/models';
import { UploadService } from '@shared/services/upload.service';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'media-picker',
  templateUrl: './media-picker.component.html',
  styleUrls: ['./media-picker.component.scss']
})
export class MediaPickerComponent implements OnChanges {

  @Input() asset: Asset | null;
  @Input() title: string;
  @Input() assetType: AssetType;
  @Input() forceContain: false;
  @Input() metadata: any = {};
  @Input() showButtons = true;
  imagePath: string;
  showLoader = false;
  @Output() selected = new EventEmitter<Asset>()

  constructor(
    private _dialog: MatDialog,
    private _uploadService: UploadService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.asset && changes.asset.currentValue) {
      if (changes.asset.previousValue && changes.asset.previousValue.id === changes.asset.currentValue.id) return;
      this.showLoader = true;
      if (this.asset.type !== AssetType.i2D && this.asset.type !== AssetType.i360 && this.asset.type !== AssetType.poster) {
        this.imagePath = this.asset.thumbnail;
      } else {
        if (this.asset.properties?.variants) {
          const smallestVariant = Object.values(this.asset.properties.variants)[0];
          this.imagePath = smallestVariant.find((variant: any) => variant.format === 'webp').path;
        } else {
          this.imagePath = this.asset.path;
        }
      }
    }
  }

  onImageLoaded(event: any) {
    if (!this.imagePath) return;
    this.showLoader = false;
  }

  onOpenFileManager(): void {
    this._dialog.open(FileManagerComponent, {
      panelClass: 'learnspace-theme',
      data: {
        title: this.title,
        type: this.assetType
      },
      id: 'file-manager'
    }).afterClosed()
      .subscribe((newAsset: Asset) => {
        if (!newAsset) return;
        this.selected.emit(newAsset);
        this.asset = newAsset;
      });
  }

}


